import { useCallback, useState } from "react";
import { ApiError } from "@/lib/api";
import { encerrarImpersonacao, iniciarImpersonacao } from "@/lib/auth-client";

interface ImpersonationResult {
    success: boolean;
    error?: string;
}

export function useImpersonation() {
    const [isLoading, setIsLoading] = useState(false);

    const startImpersonation = useCallback(async (userId: string): Promise<ImpersonationResult> => {
        setIsLoading(true);
        try {
            await iniciarImpersonacao(userId);
            // Full reload obrigatório: garante que toda a app recarregue com a nova sessão
            window.location.assign("/dashboard");
            return { success: true };
        } catch (err) {
            if (err instanceof ApiError) return { success: false, error: err.message || "Erro ao impersonar usuário" };
            return { success: false, error: "Erro de rede ao impersonar usuário" };
        } finally {
            setIsLoading(false);
        }
    }, []);

    const stopImpersonation = useCallback(async (): Promise<void> => {
        setIsLoading(true);
        try {
            await encerrarImpersonacao();
            window.location.assign("/usuarios");
        } catch {
            // Sessão do admin expirou (401 session_expired) ou não há impersonação: fail-safe para login
            window.location.assign("/login");
        }
    }, []);

    return { isLoading, startImpersonation, stopImpersonation };
}
